// The `localStorage` getter itself throws a SecurityError when the document is denied storage, so
// `if (window.localStorage)` is not a guard. That is a user setting rather than an app error, so a
// blocked read reads as absent, a blocked write is dropped, and neither is reported.

export function getStoredValue(key) {
  try {
    return window.localStorage.getItem(key)
  } catch (error) {
    return null
  }
}

export function setStoredValue(key, value) {
  try {
    window.localStorage.setItem(key, value)
  } catch (error) {
    // A blocked or full store just means the value does not persist.
  }
}
